import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesGeneralCreditSummaryComponent} from "./sales-general-credit-summary.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesGeneralCreditSummaryComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    GeneralModule
  ],
  exports: [
    SalesGeneralCreditSummaryComponent
  ]
})
export class SalesGeneralCreditSummaryModule { }
